
document.addEventListener('DOMContentLoaded', function () {

  const questions = document.querySelectorAll('.fquestion');

  questions.forEach(function (question) {

    question.addEventListener('click', function () {

      const targetClass = this.getAttribute('data');
      const targetElement = document.querySelector('.' + targetClass);

      // Check if the clicked item is already active
      const isActive = targetElement.classList.contains('active');

      // Close all FAQs
      document.querySelectorAll("div[itemprop='mainEntity']").forEach(function (item) {
        item.classList.remove('active');
      });

      // Open only if it wasn't already active
      if (!isActive) {
        targetElement.classList.add('active');
      }

    });

  });

});